export default "__VITE_ASSET__TpjjUj6C__"